export default __webpack_public_path__ + "static/media/openTask.28401499.svg";